/**
 * Request DTO for user login.
 * Synchronized with backend: com.wagandroll.waggy.auth.dto.LoginRequest
 * 
 * Validation rules:
 * - email: required, valid email format
 * - password: required, min 6 characters
 */
export class LoginRequest {
  constructor(email = '', password = '', recaptchaToken = '') {
    this.email = email;
    this.password = password;
    this.recaptchaToken = recaptchaToken;
  }

  /**
   * Validates the login request.
   * @returns {Object} { valid: boolean, errors: { email?: string, password?: string } }
   */
  validate() {
    const errors = {};

    if (!this.email || this.email.trim() === '') {
      errors.email = 'Email is required';
    } else if (!this.isValidEmail(this.email)) {
      errors.email = 'Email must be valid';
    }

    if (!this.password || this.password.trim() === '') {
      errors.password = 'Password is required';
    } else if (this.password.length < 6) {
      errors.password = 'Password must be at least 6 characters';
    }

    return {
      valid: Object.keys(errors).length === 0,
      errors
    };
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * Converts to plain object for API requests.
   */
  toJSON() {
    return {
      email: this.email,
      password: this.password,
      recaptchaToken: this.recaptchaToken
    };
  }
}
